import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import { DropdownItem } from '@atlaskit/dropdown-menu-12';

import { toggleAnnotations } from 'src/redux/pull-request/actions';
import { getHiddenAnnotations } from 'src/redux/pull-request/selectors';

import messages from '../../diff.i18n';

type Props = {
  filepath: string;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const ToggleAnnotationsItem: React.FC<Props> = React.memo(
  ({ filepath }) => {
    const dispatch = useDispatch();

    const onToggleAnnotations = useCallback(() => {
      dispatch(toggleAnnotations(filepath));
    }, [filepath, dispatch]);

    const hiddenAnnotations = useSelector(getHiddenAnnotations);

    return (
      <DropdownItem
        data-qa="pr-diff-file-annotations"
        key="file-actions-menu-annotations"
        onClick={onToggleAnnotations}
      >
        {hiddenAnnotations.includes(filepath) ? (
          <FormattedMessage {...messages.showAnnotations} />
        ) : (
          <FormattedMessage {...messages.hideAnnotations} />
        )}
      </DropdownItem>
    );
  }
);
